import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-restaurant-tags',
  templateUrl: './restaurant-tags.component.html'
})
export class RestaurantTagsComponent implements OnInit {
  @Input() tags:string[];
  
  constructor() { }
  ngOnInit() { }

}
